import { apiService } from './index';

// Inport types
import {
    StrategicAlly,
    StrategicAllyFilter,
} from '../shared/types/modules/strategicAlly';
import { cleanObj } from '../shared/utils/objects';

export const asyncGetStrategicAllys = async (
    filters: StrategicAllyFilter,
    page?: number,
    pageSize?: number
): Promise<{ items: StrategicAlly[]; length: 0 }> => {
    try {
        const items: { items: StrategicAlly[]; length: 0 } =
            await apiService.get(`/api/strategic-ally`, {
                limit: pageSize || 20,
                page: page || 0,
                ...cleanObj(filters),
            });

        return items || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};
